import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/fintech.css';

/* ---------- Small reusable pieces ---------- */

const CheckIcon = ({ className = 'w-4 h-4' }) => (
  <svg viewBox="0 0 20 20" fill="none" className={className} aria-hidden="true">
    <path d="M4 10.5l4 4 8-9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const ShieldIcon = ({ className = 'w-4 h-4' }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <path
      d="M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6l7-3z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
  </svg>
);

/* ---------- Top utility bar ---------- */

const GovBanner = () => (
  <div className="bg-gray-100 border-b border-gray-200 text-[13px] text-gray-700">
    <div className="max-w-5xl mx-auto px-4 py-2 flex items-center gap-2">
      <span aria-hidden="true">🇺🇸</span>
      <span>An official website of the United States government</span>
    </div>
    <div className="max-w-5xl mx-auto px-4 pb-2">
      <a href="#" className="text-[#1a4b8c] hover:underline">
        Cambiar a español
      </a>
    </div>
  </div>
);

/* ---------- Navy header ---------- */

const SiteHeader = () => (
  <header className="bg-[#0b2740] text-white">
    <div className="max-w-5xl mx-auto px-4 h-16 flex items-center justify-between">
      <Link to="/fintech" className="text-xl font-bold tracking-[0.2em]">
        FDIC
      </Link>
      <button aria-label="Open menu" className="p-2 -mr-2">
        <span className="block w-6 h-0.5 bg-white mb-1.5" />
        <span className="block w-6 h-0.5 bg-white mb-1.5" />
        <span className="block w-6 h-0.5 bg-white" />
      </button>
    </div>
  </header>
);

/* ---------- Partner logos strip ---------- */

const PartnerLogos = () => (
  <div className="bg-white border-b border-gray-200">
    <div className="max-w-5xl mx-auto px-4 py-4 flex items-center justify-between gap-6">
      {/* Replace these with real logo assets when you have them */}
      <img src="/fintech/logo-capitalone.png" alt="Capital One" className="h-6 object-contain" />
      <img src="/fintech/logo-citi.png" alt="Citi" className="h-6 object-contain" />
      <img src="/fintech/logo-pnc.png" alt="PNC" className="h-6 object-contain" />
      <img src="/fintech/logo-usbank.png" alt="US Bank" className="h-6 object-contain" />
    </div>
  </div>
);

/* ---------- Hero section ---------- */

const Hero = () => (
  <section className="max-w-5xl mx-auto px-4 pt-10 pb-12">
    {/* Badge */}
    <div className="inline-flex items-center gap-2 bg-[#e8f3ec] text-[#1f5c3a] text-xs font-medium px-3 py-1.5 rounded-full">
      <CheckIcon className="w-3.5 h-3.5" />
      Federally Insured · Member FDIC
    </div>

    {/* Headline */}
    <h1 className="mt-6 font-serif text-[44px] leading-[1.05] text-[#1a2b3c]">
      Your deposits,
      <br />
      <em className="italic">always protected.</em>
    </h1>

    {/* Body */}
    <p className="mt-6 text-[15px] leading-7 text-gray-600 max-w-xl">
      The Federal Deposit Insurance Corporation safeguards your financial future.
      Government-backed deposit insurance, certified banking oversight, and the
      tools you need to bank with complete confidence.
    </p>

    {/* Bullets */}
    <ul className="mt-6 space-y-3 text-[15px]">
      <li className="flex items-center gap-2 text-[#1f5c3a] font-semibold">
        <CheckIcon className="w-4 h-4" />
        Deposits insured up to $250,000
      </li>
      <li className="flex items-center gap-2 text-[#1f5c3a] font-semibold">
        <ShieldIcon className="w-4 h-4" />
        Federal oversight, 24 hours a day
      </li>
    </ul>
  </section>
);



/*------------vewi 2 -----------*/
/* ---------- Auth actions (Sign In / Verify an Agent) ---------- */

const SignInArrowIcon = ({ className = 'w-4 h-4' }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <path
      d="M10 7l-4 5 4 5M6 12h10M15 7h4a1 1 0 011 1v8a1 1 0 01-1 1h-4"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const VerifyShieldIcon = ({ className = 'w-4 h-4' }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <path
      d="M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6l7-3z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const AuthActions = () => (
  <section className="max-w-5xl mx-auto px-4 pb-10 flex flex-wrap gap-3">
    <Link
      to="/fintech/login"
      className="inline-flex items-center gap-2 bg-[#0b2740] text-white text-sm font-semibold px-5 py-3 rounded-lg hover:bg-[#12324f] transition-colors"
    >
      <SignInArrowIcon />
      Sign In
    </Link>
    <button
      type="button"
      className="inline-flex items-center gap-2 border border-[#0b2740] text-[#0b2740] text-sm font-semibold px-5 py-3 rounded-lg hover:bg-[#0b2740] hover:text-white transition-colors"
    >
      <VerifyShieldIcon />
      Verify an Agent
    </button>
  </section>
);

/* ---------- Navy stats band ---------- */

const StatItem = ({ value, label }) => (
  <div className="text-center">
    <div className="text-3xl sm:text-4xl font-bold text-white tracking-tight">{value}</div>
    <div className="mt-1 text-[13px] text-white/70">{label}</div>
  </div>
);

const StatsBand = () => (
  <section className="bg-[#0b2740] text-white">
    <div className="max-w-5xl mx-auto px-6 py-12 grid grid-cols-2 gap-y-10 gap-x-6">
      <StatItem value="4,706" label="Federally Insured Banks" />
      <StatItem value="250K" label="Max. Per-Depositor Cover" />
      <StatItem value="91" label="Years Protecting Deposits" />
      <StatItem value="23T+" label="Total Assets Supervised" />
    </div>
  </section>
);

/* ---------- "Why FDIC" intro ---------- */

const WhyFdicIntro = () => (
  <section className="bg-gray-50">
    <div className="max-w-3xl mx-auto px-4 py-16 text-center">
      {/* Pill */}
      <div className="inline-flex items-center gap-2 bg-[#e8f3ec] text-[#1f5c3a] text-[11px] font-semibold tracking-[0.15em] uppercase px-3 py-1.5 rounded-full">
        <span className="w-1.5 h-1.5 rounded-full bg-[#1f5c3a]" />
        Why FDIC
      </div>

      {/* Headline */}
      <h2 className="mt-6 font-serif text-[40px] leading-[1.1] text-[#1a2b3c]">
        Built on trust.
        <br />
        Backed by the U.S.
        <br />
        Government.
      </h2>

      {/* Body */}
      <p className="mt-6 text-[15px] leading-7 text-gray-600">
        For over nine decades, the FDIC has stood between American families and
        financial loss. Here is what that commitment looks like in practice.
      </p>
    </div>
  </section>
);

/*-----third section----*/
/* ---------- Feature card (shared) ---------- */

const FeatureCard = ({ icon, title, children, badge }) => (
  <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 sm:p-8">
    {/* Icon tile */}
    <div className="w-12 h-12 rounded-lg bg-[#eef1f4] flex items-center justify-center text-[#0b2740]">
      {icon}
    </div>

    {/* Title */}
    <h3 className="mt-5 font-serif text-[22px] leading-snug text-[#1a2b3c]">
      {title}
    </h3>

    {/* Body */}
    <p className="mt-3 text-[14px] leading-6 text-gray-600">{children}</p>

    {/* Badge pill */}
    {badge && (
      <div className="mt-5">
        <span className="inline-flex items-center gap-2 bg-[#0b2740] text-white text-[12px] font-medium px-3 py-1.5 rounded-full">
          <BadgeIcon />
          {badge}
        </span>
      </div>
    )}
  </div>
);

const BadgeIcon = ({ className = 'w-3.5 h-3.5' }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <path
      d="M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6l7-3z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

/* ---------- Icons for the three feature cards ---------- */

const DepositShieldIcon = ({ className = 'w-6 h-6' }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <path
      d="M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6l7-3z"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const BenefitsTreeIcon = ({ className = 'w-6 h-6' }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <circle cx="12" cy="6" r="2.2" stroke="currentColor" strokeWidth="1.6" />
    <path
      d="M12 8.5v4M7 21c0-3 2.5-5 5-5s5 2 5 5"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
    <circle cx="5" cy="15" r="1.8" stroke="currentColor" strokeWidth="1.6" />
    <circle cx="19" cy="15" r="1.8" stroke="currentColor" strokeWidth="1.6" />
  </svg>
);

const BankBookIcon = ({ className = 'w-6 h-6' }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <rect x="4" y="4" width="16" height="16" rx="2" stroke="currentColor" strokeWidth="1.6" />
    <path d="M4 10h16M9 4v16" stroke="currentColor" strokeWidth="1.6" />
    <path d="M13 15l1.8 1.8L18 13.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

/* ---------- Feature cards section ---------- */

const FeatureCards = () => (
  <section className="bg-gray-50">
    <div className="max-w-3xl mx-auto px-4 pb-16 space-y-6">
      <FeatureCard
        icon={<DepositShieldIcon />}
        title="Deposit Insurance"
        badge="Insured up to $250,000"
      >
        Every dollar you deposit is federally insured up to $250,000 per depositor,
        per institution — backed by the full faith and credit of the United States
        government since 1933.
      </FeatureCard>

      <FeatureCard
        icon={<BenefitsTreeIcon />}
        title="Member Benefits & Rewards"
        badge="Earn on every transaction"
      >
        Eligible account holders earn points on qualifying transactions, redeemable
        for cashback, travel credits, and exclusive financial perks through our
        network of certified partner institutions.
      </FeatureCard>

      <FeatureCard
        icon={<BankBookIcon />}
        title="Bank Securely, Always"
        badge="Zero-tolerance fraud policy"
      >
        Our institutions are held to the highest federal security standards —
        mandatory multi-factor authentication, real-time anomaly detection, and
        end-to-end encryption on every account.
      </FeatureCard>
    </div>
  </section>
);


/*---------- fourth & fifth view----*/
/* ---------- Protecting depositors panel ---------- */

const ProtectingPeopleIcon = ({ className = 'w-6 h-6' }) => (
  <svg viewBox="0 0 24 24" fill="none" className={className} aria-hidden="true">
    <circle cx="9" cy="8" r="3" stroke="currentColor" strokeWidth="1.6" />
    <circle cx="17" cy="9" r="2.2" stroke="currentColor" strokeWidth="1.6" />
    <path
      d="M3 19c0-3 2.7-5 6-5s6 2 6 5M14 19c0-2.4 1.8-4 4-4s3 1.2 3 3"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </svg>
);

const ProtectingPanel = () => (
  <section className="bg-white">
    <div className="max-w-3xl mx-auto px-4 pb-16">
      <div className="rounded-2xl bg-[#0b2740] text-white p-6 sm:p-8">
        {/* Icon + eyebrow + headline */}
        <div className="flex items-start gap-4">
          <div className="w-12 h-12 rounded-lg bg-white/10 flex items-center justify-center text-white shrink-0">
            <ProtectingPeopleIcon />
          </div>
          <div>
            <div className="text-[11px] font-semibold tracking-[0.18em] uppercase text-white/70">
              Protecting
            </div>
            <h3 className="mt-1 font-serif text-[26px] leading-tight text-white">
              130M+ American
              <br />
              Depositors
            </h3>
          </div>
        </div>

        {/* Checklist */}
        <ul className="mt-8 space-y-5 text-[14px] leading-6 text-white/85">
          <li className="flex items-start gap-3">
            <CheckIcon className="w-4 h-4 mt-1 text-white shrink-0" />
            <span>Mandatory two-factor authentication on all accounts</span>
          </li>
          <li className="flex items-start gap-3">
            <CheckIcon className="w-4 h-4 mt-1 text-white shrink-0" />
            <span>Real-time transaction anomaly detection &amp; alerts</span>
          </li>
          <li className="flex items-start gap-3">
            <CheckIcon className="w-4 h-4 mt-1 text-white shrink-0" />
            <span>AES-256 end-to-end encrypted data in transit and at rest</span>
          </li>
          <li className="flex items-start gap-3">
            <CheckIcon className="w-4 h-4 mt-1 text-white shrink-0" />
            <span>Full faith &amp; credit of the U.S. government behind every dollar</span>
          </li>
        </ul>

        {/* Sign In button */}
        <Link
          to="/fintech/login"
          className="mt-8 block w-full text-center bg-white text-[#0b2740] font-semibold text-[15px] py-3.5 rounded-lg hover:bg-gray-100 transition-colors"
        >
          Sign In
        </Link>
      </div>
    </div>
  </section>
);

/*-----------6th view-------*/

/* ---------- Nine decades section ---------- */

const EstablishedPill = () => (
  <div className="inline-flex items-center gap-2 bg-[#e8f3ec] text-[#1f5c3a] text-[11px] font-semibold tracking-[0.15em] uppercase px-3 py-1.5 rounded-full">
    <span className="w-1.5 h-1.5 rounded-full bg-[#1f5c3a]" />
    Established by Congress · June 16, 1933
  </div>
);

const NineDecadesSection = () => (
  <section className="bg-[#f4f6f8]">
    <div className="max-w-3xl mx-auto px-4 py-16 text-left">
      <EstablishedPill />

      <h2 className="mt-6 font-serif text-[36px] leading-[1.15] text-[#1a2b3c]">
        Nine decades of
        <br />
        unwavering financial
        <br />
        protection
      </h2>

      <p className="mt-6 text-[15px] leading-7 text-gray-600">
        Created during the Great Depression to restore public trust in America's
        banking system, the FDIC has never failed to honor an insured deposit. Not
        once in over 90 years of operation, no depositor has lost a single insured
        cent.
      </p>

      <p className="mt-5 text-[15px] leading-7 text-gray-600">
        Today we supervise more than 4,700 financial institutions, enforce
        consumer protection laws, and stand ready to resolve failing banks — all
        without cost to taxpayers.
      </p>

      <button
        type="button"
        className="mt-8 inline-flex items-center gap-2 bg-[#5b7a92] hover:bg-[#4a6478] text-white text-[14px] font-semibold px-5 py-3 rounded-lg transition-colors"
      >
        <VerifyShieldIcon />
        Verify an Agent
      </button>
    </div>
  </section>
);
/*----------7th view----*/
/* ---------- Trusted delivery partners ---------- */

const PartnerLogoTile = ({ src, alt }) => (
  <div className="bg-white rounded-xl shadow-sm border border-gray-100 h-24 flex items-center justify-center px-6">
    <img src={src} alt={alt} className="max-h-8 w-auto object-contain" />
  </div>
);

const TrustedPartnersSection = () => (
  <section className="bg-[#f4f6f8]">
    <div className="max-w-3xl mx-auto px-4 py-16 text-center">
      <h2 className="font-serif text-[32px] leading-tight text-[#1a2b3c]">
        Our Trusted Delivery
        <br />
        Partners
      </h2>

      <div className="mt-10 grid grid-cols-2 gap-4">
        <PartnerLogoTile src="/fintech/logo-ups.png" alt="UPS" />
        <PartnerLogoTile src="/fintech/logo-dhl.png" alt="DHL" />
        <PartnerLogoTile src="/fintech/logo-amazon.png" alt="Amazon" />
        <PartnerLogoTile src="/fintech/logo-usps.png" alt="United States Postal Service" />
      </div>
    </div>
  </section>
);
/* ---------- Footer ---------- */

const FooterLink = ({ href = '#', children, external }) => (
  <a
    href={href}
    {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
    className="text-[11px] font-medium tracking-[0.18em] uppercase text-white/70 hover:text-white transition-colors inline-flex items-center gap-1"
  >
    {children}
    {external && (
      <svg viewBox="0 0 12 12" className="w-2.5 h-2.5" fill="none" aria-hidden="true">
        <path
          d="M4 2h6v6M10 2L4 8M8 6v3a1 1 0 01-1 1H3a1 1 0 01-1-1V5a1 1 0 011-1h3"
          stroke="currentColor"
          strokeWidth="1.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )}
  </a>
);

const SiteFooter = () => (
  <footer className="bg-[#0b2740] text-white">
    <div className="max-w-3xl mx-auto px-4 py-12">
      {/* Row 1 */}
      <div className="flex flex-wrap justify-center gap-x-8 gap-y-4">
        <FooterLink>Policies</FooterLink>
        <FooterLink>Help</FooterLink>
        <FooterLink>FOIA</FooterLink>
        <FooterLink>En Español</FooterLink>
      </div>

      {/* Row 2 */}
      <div className="mt-4 flex flex-wrap justify-center gap-x-8 gap-y-4">
        <FooterLink>Accessibility</FooterLink>
        <FooterLink>Open Government</FooterLink>
        <FooterLink external>USA.gov</FooterLink>
      </div>

      {/* Row 3 */}
      <div className="mt-8 flex flex-wrap justify-center gap-x-8 gap-y-4">
        <FooterLink>Contact Us</FooterLink>
      </div>

      {/* Row 4 */}
      <div className="mt-4 flex flex-wrap justify-center gap-x-8 gap-y-4">
        <FooterLink>Privacy</FooterLink>
        <FooterLink>Plain Writing</FooterLink>
        <FooterLink>No Fear Act Data</FooterLink>
      </div>

      {/* Row 5 */}
      <div className="mt-4 flex flex-wrap justify-center gap-x-8 gap-y-4">
        <FooterLink external>Inspector General</FooterLink>
      </div>
    </div>
  </footer>
);
/* ---------- Page ---------- */

const FintechLanding = () => {
  return (
    <div className="bg-white min-h-screen">
      <GovBanner />
      <SiteHeader />
      <PartnerLogos />
      <Hero />

      <AuthActions />
      <StatsBand />
      <WhyFdicIntro />
      <FeatureCards />
      <ProtectingPanel />
      <NineDecadesSection />
      <TrustedPartnersSection />
      <SiteFooter />
      {/* ... next sections will go here as we build them ... */}
    </div>
  );
};

export default FintechLanding;